import { React } from '@gasbuddy/react';
import { Segment, Container } from 'semantic-ui-react';
import { Auth, Nav } from '../components';

export * from './identity';
export * from './auth';
export * from './system';
export * from './payments';
export * from './errors';
export * from './reports';
export * from './poi';
export * from './loyalty';

export const Home = () => (
  <Auth forRoles="admin">
    <Nav>
      <Container text>
        <h1>GasBuddy Administration</h1>
        <Segment style={{ fontSize: '20px' }}>
          <p>Use the navigation on the left to find the tool you need.</p>
          <p>
Only tools to which you have been granted access will appear there,
      so if something is missing talk to max@gasbuddy.com
          </p>
        </Segment>
      </Container>
    </Nav>
  </Auth>
);
